import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svg_close",
  "use": "svg_close-usage",
  "viewBox": "0 0 9 9",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 9 9\" id=\"svg_close\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M8.157.843a1 1 0 0 0-1.415 0L4.5 3.086 2.257.843A1 1 0 1 0 .843 2.258L3.085 4.5.843 6.743a1 1 0 1 0 1.414 1.414L4.5 5.914l2.242 2.243a1 1 0 0 0 1.414-1.414L5.914 4.5l2.243-2.243a1 1 0 0 0 0-1.414Z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol